"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SigmaModelEntryFormPayloadSchema = void 0;
const sigma_engine_shared_1 = require("@cadstrom/sigma-engine-shared");
const z = require("zod");
const misc_1 = require("../../../misc");
exports.SigmaModelEntryFormPayloadSchema = z.object({
    sigmaModelType: z.string(),
    parameters: misc_1.pkgParametersSchema,
    signals: sigma_engine_shared_1.SignalSchema.array(),
    pinout: misc_1.pkgPinoutSchema,
    spiceModels: sigma_engine_shared_1.SPICE.ISubModelOptsSchema.array().default([]),
});
//# sourceMappingURL=payload.js.map